var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "menu-svg",
    d: "M5.80001 7.9C3.53001 7.31 2.80001 6.7 2.80001 5.75C2.80001 4.66 3.81001 3.9 5.50001 3.9C7.28001 3.9 7.94001 4.75 8.00001 6H10.21C10.14 4.28 9.09001 2.7 7.00001 2.19V0H4.00001V2.16C2.06001 2.58 0.500007 3.84 0.500007 5.77C0.500007 8.08 2.41001 9.23 5.20001 9.9C7.70001 10.5 8.20001 11.38 8.20001 12.31C8.20001 13 7.71001 14.1 5.50001 14.1C3.44001 14.1 2.63001 13.18 2.52001 12H0.320007C0.440007 14.19 2.08001 15.42 4.00001 15.83V18H7.00001V15.85C8.95001 15.48 10.5 14.35 10.5 12.3C10.5 9.46 8.07001 8.49 5.80001 7.9Z",
    fill: "#828282"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/Invoices.0b9258c0.svg";
export { ForwardRef as ReactComponent };